/* StylinArts product card + responsive image scripts (moved 2026-11-05, loaded once with defer). */
(function(){

  if (window.saUnifiedUXReady) return;
  window.saUnifiedUXReady = true;

  /* ------------------------------
     COLOR DOTS
  ------------------------------ */
  function swapImage(dot, makeActive) {
    var info = dot.closest('.sa-pl-info');
    if (!info) return;

    var card = info.previousElementSibling;
    if (!card || !card.classList.contains('sa-pl-card')) return;

    var img = card.querySelector('.sa-pl-media img');
    var encodedSource = dot.getAttribute('data-sa-image-source');

    if (!img || !encodedSource) return;

    var newImage = '/img?src='
      + encodedSource
      + '&preset=collection&w=760';

    if (makeActive) {
      info.querySelectorAll('[data-sa-color-dot]').forEach(function(btn){
        btn.classList.remove('is-active');
      });
      dot.classList.add('is-active');
    }

    if (img.getAttribute('src') === newImage) return;

    img.style.opacity = '0';

    setTimeout(function(){
      img.setAttribute('src', newImage);
      img.removeAttribute('srcset');
      img.setAttribute('sizes', '100vw');
      img.style.opacity = '1';
    }, 140);
  }

  document.addEventListener('click', function(e){
    var dot = e.target.closest('[data-sa-color-dot]');
    if (!dot) return;
    swapImage(dot, true);
  });

  document.addEventListener('mouseover', function(e){
    var dot = e.target.closest('[data-sa-color-dot]');
    if (!dot) return;

    if (window.matchMedia('(hover: hover)').matches) {
      swapImage(dot, false);
    }
  });

  /* ------------------------------
     VIDEO SMOOTH START
  ------------------------------ */
  function initVideos(){
    document.querySelectorAll('.sa-pl-card video').forEach(function(video){
      var card = video.closest('.sa-pl-card');
      if (!card) return;

function markReady(){
  video.setAttribute('data-sa-video-ready', 'true');
  card.classList.add('is-video-ready');
}

      if (video.readyState >= 2) {
        markReady();
      } else {
        video.addEventListener('loadeddata', markReady, { once: true });
        video.addEventListener('canplay', markReady, { once: true });
      }

      video.setAttribute('playsinline', '');
      video.muted = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideos);
  } else {
    initVideos();
  }

})();

(function () {
  if (window.saLcpImageIntelligenceReady) return;
  window.saLcpImageIntelligenceReady = true;

  var DEBUG = false;
  var selected = null;
  var preloadInserted = false;

  function log() {
    if (!DEBUG || !window.console) return;
    console.log.apply(console, arguments);
  }

  function isElementVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;

    var rect = el.getBoundingClientRect();
    var style = window.getComputedStyle ? window.getComputedStyle(el) : null;

    if (style && (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0)) {
      return false;
    }

    if (rect.width < 80 || rect.height < 80) return false;
    if (rect.bottom <= 0) return false;
    if (rect.top >= window.innerHeight) return false;
    if (rect.right <= 0) return false;
    if (rect.left >= window.innerWidth) return false;

    return true;
  }

  function scoreImage(img) {
    var rect = img.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 800;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1200;

    var visibleTop = Math.max(rect.top, 0);
    var visibleBottom = Math.min(rect.bottom, viewportHeight);
    var visibleLeft = Math.max(rect.left, 0);
    var visibleRight = Math.min(rect.right, viewportWidth);

    var visibleWidth = Math.max(0, visibleRight - visibleLeft);
    var visibleHeight = Math.max(0, visibleBottom - visibleTop);
    var visibleArea = visibleWidth * visibleHeight;
    var totalArea = Math.max(1, rect.width * rect.height);
    var visibleRatio = visibleArea / totalArea;

    var topPenalty = Math.max(0, rect.top) * 0.85;
    var areaScore = visibleArea * visibleRatio;

    return areaScore - topPenalty;
  }

  function getCandidates() {
    return Array.prototype.slice.call(
      document.querySelectorAll('img[data-sa-lcp-candidate="true"]')
    ).filter(isElementVisible);
  }

  function insertPreload(img) {
    if (!img || preloadInserted) return;

    var href = img.currentSrc || img.src;
    if (!href) return;

    var link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = href;

    var srcset = img.getAttribute('srcset');
    var sizes = img.getAttribute('sizes');

    if (srcset) link.setAttribute('imagesrcset', srcset);
    if (sizes) link.setAttribute('imagesizes', sizes);

    link.setAttribute('fetchpriority', 'high');
    link.setAttribute('data-sa-lcp-preload', 'true');

    document.head.appendChild(link);
    preloadInserted = true;

    log('[SA LCP] preload inserted', href);
  }

  function prioritiseImage(img) {
    if (!img) return;

    selected = img;

    img.setAttribute('data-sa-lcp-selected', 'true');
    img.setAttribute('fetchpriority', 'high');
    img.setAttribute('loading', 'eager');
    img.setAttribute('decoding', 'async');

    if ('fetchPriority' in img) {
      try {
        img.fetchPriority = 'high';
      } catch (e) {}
    }

    insertPreload(img);
  }

  function detectLikelyLcp() {
    if (selected) return selected;

    var candidates = getCandidates();
    if (!candidates.length) return null;

    var winner = candidates
      .map(function (img) {
        return {
          img: img,
          score: scoreImage(img)
        };
      })
      .sort(function (a, b) {
        return b.score - a.score;
      })[0];

    if (!winner || !winner.img) return null;

    prioritiseImage(winner.img);

    log('[SA LCP] likely candidate selected', winner.img, winner.score);

    return winner.img;
  }

  function confirmActualLcp() {
    if (!('PerformanceObserver' in window)) return;

    try {
      var observer = new PerformanceObserver(function (entryList) {
        var entries = entryList.getEntries();
        var last = entries[entries.length - 1];

        if (!last) return;

        var el = last.element;

        document.documentElement.setAttribute('data-sa-lcp-time', Math.round(last.startTime));

        if (el && el.tagName === 'IMG') {
          el.setAttribute('data-sa-lcp-actual', 'true');
          document.documentElement.setAttribute('data-sa-lcp-element', 'image');

          if (el.currentSrc || el.src) {
            document.documentElement.setAttribute('data-sa-lcp-src', el.currentSrc || el.src);
          }

          log('[SA LCP] actual image LCP confirmed', Math.round(last.startTime), el);
        } else {
          document.documentElement.setAttribute('data-sa-lcp-element', el ? el.tagName.toLowerCase() : 'unknown');
          log('[SA LCP] actual LCP was not image', last);
        }
      });

      observer.observe({
        type: 'largest-contentful-paint',
        buffered: true
      });
    } catch (e) {}
  }

  function runSoon() {
    detectLikelyLcp();

    if (window.requestAnimationFrame) {
      requestAnimationFrame(function () {
        detectLikelyLcp();
      });
    }

    setTimeout(detectLikelyLcp, 120);
  }

  confirmActualLcp();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runSoon, { once: true });
  } else {
    runSoon();
  }

  window.addEventListener('pageshow', function () {
    if (!selected) runSoon();
  }, { once: true });
})();
